import { useDispatch } from 'react-redux';
import { FC, useEffect } from 'react';

import { CreateAccount } from './steps/CreateAccount';
import { PersonalInformation } from './steps/PersonalInformation';
import { VerifyEmail } from './steps/VerifyEmail';

import { leaveRegistration } from 'features/registration/registrationSlice';
import { getUserProfile } from 'features/user/actions';

import { removeFromStorage } from 'utils';
import { ClientStatus, TIMER_STORAGE } from 'utils/constants';
import { AppDispatch } from 'store';
import { useAppSelector } from 'hooks';

export const Register: FC = () => {
	const user = useAppSelector((state) => state.user.entity);
	const register = useAppSelector((state) => state.registration);

	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		return () => {
			dispatch(leaveRegistration());
			removeFromStorage(TIMER_STORAGE);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (user.status === ClientStatus.INCOMPLETE && !user.id) {
			dispatch(getUserProfile());
		}
	}, [dispatch, user.id, user.status]);
	if (user.status === ClientStatus.INCOMPLETE) {
		return <PersonalInformation />;
	}

	switch (register.step) {
		case 2:
			return <PersonalInformation />;
		case 1:
			return <VerifyEmail />;
		default:
			return <CreateAccount />;
	}
};
